import { AuthInfo } from '../types/auth'

const initialState: AuthInfo = {
  name: '',
  email: '',
  username: '',
  idToken: '',
  id: '',
  companyName: '',
  companyType: '',
  isPremium: false,
  isVendor: false,
  hasVendorCentralAccess: false,
  isSSOUser: false,
  vendor: '',
  publishedAt: '',
  premiumOrganizationId: null,
  premiumOrganizationName: null,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'SET_AUTH':
      return {
        ...state,
        // Ensure we persist email and other auth fields when available
        email: action.payload.email ?? state.email,
        username: action.payload.username ?? state.username,
        idToken: action.payload.idToken ?? state.idToken,
        isSSOUser: action.payload.isSSOUser ?? state.isSSOUser,
        vendor: action.payload.vendor ?? state.vendor,
        publishedAt: action.payload.publishedAt ?? state.publishedAt,
      }
    case 'SET_PROFILE':
      return {
        ...state,
        name: action.payload.name,
        // Profile updates may also include email and vendor metadata
        email: action.payload.email ?? state.email,
        id: action.payload.id ?? state.id,
        companyName: action.payload.companyName ?? state.companyName,
        companyType: action.payload.companyType ?? state.companyType,
        isPremium: action.payload.isPremium ?? state.isPremium,
        isVendor: action.payload.isVendor ?? state.isVendor,
        hasVendorCentralAccess: action.payload.hasVendorCentralAccess ?? state.hasVendorCentralAccess,
        vendor: action.payload.vendor ?? state.vendor,
        publishedAt: action.payload.publishedAt ?? state.publishedAt,
        premiumOrganizationId: action.payload.premiumOrganizationId ?? state.premiumOrganizationId,
        premiumOrganizationName: action.payload.premiumOrganizationName ?? state.premiumOrganizationName,
      }
    case 'SET_EMAIL':
      return {
        ...state,
        email: action.payload.email,
      }
    case 'SET_VENDOR':
      return {
        ...state,
        vendor: action.payload.vendor,
      }
    case 'SET_PUBLISHEDAT':
      return {
        ...state,
        publishedAt: action.payload.publishedAt,
      }
    case 'CLEAR_AUTH':
      return {
        ...initialState,
      }
    default:
      return state
  }
}

export default authReducer
